import CityPageTemplate from "../city-template/CityPageTemplate";
import { towsonConfig } from "./data";

export default function TowsonPage() {
  return <CityPageTemplate config={towsonConfig} />;
}